export default {
  state: {
    deductionForm: {
      show: false,
      interval: ['weekly', 'monthly'],
      weeklyAnchor: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
      ],
      monthlyAnchor: 31,
      id: null,
      name: '',
      description: '',
      amount: 0,
      effectiveStart: null,
      effectiveEnd: null,
      enabled: false,
      selectedInterval: 'weekly',
      selectedWeeklyAnchor: 'monday',
      selectedMonthlyAnchor: 1,
      applyTNC: false,
      applyTCP: false,
      applyPSC: false
    }
  },
  mutations: {
    setDeductionFormShow (state, value) { state.deductionForm.show = value },
    setDeductionFormId (state, value) { state.deductionForm.id = value },
    setDeductionFormName (state, value) { state.deductionForm.name = value },
    setDeductionFormDescription (state, value) { state.deductionForm.description = value },
    setDeductionFormAmount (state, value) { state.deductionForm.amount = value },
    setDeductionFormEffectiveStart (state, value) { state.deductionForm.effectiveStart = value },
    setDeductionFormEffectiveEnd (state, value) { state.deductionForm.effectiveEnd = value },
    setDeductionFormEnabled (state, value) { state.deductionForm.enabled = value },
    setDeductionFormSelectedInterval (state, value) { state.deductionForm.selectedInterval = value },
    setDeductionFormSelectedWeeklyAnchor (state, value) { state.deductionForm.selectedWeeklyAnchor = value },
    setDeductionFormSelectedMonthlyAnchor (state, value) { state.deductionForm.selectedMonthlyAnchor = value },
    setDeductionFormApplyTNC (state, value) { state.deductionForm.applyTNC = value },
    setDeductionFormApplyTCP (state, value) { state.deductionForm.applyTCP = value },
    setDeductionFormApplyPSC (state, value) { state.deductionForm.applyPSC = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/provider-deductions/deduction-form.js